import React from 'react';
import { connect } from 'react-redux';
import { Container } from 'semantic-ui-react';
import { goBack, push } from 'connected-react-router';
import { RouteComponentProps } from 'react-router';
import useAxios from 'axios-hooks';
import { EEhsType, IBuilding } from '@relab/alstom-ptw-shared';

import { HeaderComponent } from '../components/HeaderComponent';
import { NavBar } from '../components/NavBar';
import { EhsCreateComponent } from '../components/ehs/EhsCreateComponent';

interface EhsCreateSceneProps extends RouteComponentProps<{ ehsId: string | undefined }> {
  goBack: typeof goBack;
  push: typeof push;
}

const PEhsCreateScene: React.FC<EhsCreateSceneProps> = ({ goBack, push, location }) => {
  const params = new URLSearchParams(location.search);
  const ehsType = params.get('ehsType') as EEhsType;

  const [{ data: buildings = [] }] = useAxios<IBuilding[]>('/buildings');

  return (
    <>
      <HeaderComponent />
      <NavBar />
      <Container fluid>
        <EhsCreateComponent
          ehsType={ehsType}
          buildings={buildings}
          onCancel={goBack}
          onComplete={() => push(`/ehss`)}
        />
      </Container>
    </>
  );
};

export const EhsCreateScene = connect(null, { goBack, push })(PEhsCreateScene);
